import {I18n} from '@aws-amplify/core';

import {FlexiButton,} from '@flexinet/ui-components';
import {useUserAccount} from "../../../../hooks/useUserAccount.ts";
import {useEnableAccountApplicationMutation} from "../../account-applications/hooks/useAccountApplicationsQuery";
import {ALREADY_ACTIVE_MESSAGE} from "../../account-applications/services/AccountApplicationsService";
import {
    notifySuccess,
    showErrorNotification
} from "../../../../components/PlatformNotification";
import {Application} from "../types.ts";
import {AiOutlineCheck} from 'react-icons/ai';

export const EnableRecordButton = ({
                                       record
                                   }: {
    record: Application
}) => {

    const {userAccount} = useUserAccount();

    if (!userAccount) {
        throw new Error('User account not found');
    }

    // FNP-2070: the one enable path. It creates with ACTIVE (FNP-899: without
    // ACTIVE console-api opens no seat), and since FNP-902 that same create
    // reactivates a Disabled record in place rather than adding a second one.
    const enableMutation = useEnableAccountApplicationMutation();

    const onClick = () => {
        enableMutation.mutate({accountId: userAccount.id, applicationId: record.id}, {
            onSuccess: ({alreadyActive}) => notifySuccess(alreadyActive ? ALREADY_ACTIVE_MESSAGE : I18n.get('Application enabled')),
            onError: (e) => showErrorNotification(e.message),
        });
    };
    return (
        <FlexiButton
            leftSection={<AiOutlineCheck/>}
            onClick={onClick}
            loading={enableMutation.isPending}
            size={'md'}
        >
            {I18n.get('Enable')}
        </FlexiButton>
    );
};
